import { render, staticRenderFns } from "./UserServicepointsTableAction.vue?vue&type=template&id=1e59a1e4&scoped=true"
import script from "./UserServicepointsTableAction.vue?vue&type=script&lang=ts"
export * from "./UserServicepointsTableAction.vue?vue&type=script&lang=ts"
import style0 from "./UserServicepointsTableAction.vue?vue&type=style&index=0&id=1e59a1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e59a1e4",
  null
  
)

export default component.exports